export default __webpack_public_path__ + "static/24934220-night-1ebe40acf91f4eaa5fa934c1bc8d4eff.mp4";